var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftThird(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 269,
    viewBox: "0 0 295 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14008_88924)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14008_88924)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 407,
    rx: 8,
    fill: "#EEF0FC"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 44,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 167,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 73,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 89,
    width: 263,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    fill: "#2356F6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    stroke: "#2356F6",
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.2043 153.128C36.5483 153.128 37.6363 152.44 37.9563 151.384V153H40.4523V148.472C40.4523 147.64 39.8443 146.712 38.7083 146.712H35.5563V148.792H37.5563C37.7163 148.792 37.8123 148.904 37.8123 149.08C37.8123 149.864 36.5643 150.856 35.3643 150.856C33.6843 150.856 32.3243 149.464 32.3243 147.4C32.3243 145.336 33.6843 144.104 35.4123 144.104C36.7403 144.104 37.5563 144.792 37.7003 145.88H40.4843C40.3883 143.384 38.3563 141.672 35.4443 141.672C32.4043 141.672 29.6363 143.576 29.6363 147.4C29.6363 151.224 32.3083 153.128 35.2043 153.128ZM41.9075 153H44.5475V144.936H41.9075V153ZM41.8595 143.944H44.6115V141.352H41.8595V143.944ZM48.2576 153H50.5936L53.5376 144.936H50.8496L49.4256 149.624L47.9856 144.936H45.3136L48.2576 153ZM54.2981 153H56.9381V144.936H54.2981V153ZM54.2501 143.944H57.0021V141.352H54.2501V143.944ZM58.3763 153H61.0163V148.552C61.0163 147.752 61.5763 147.144 62.3763 147.144C63.1763 147.144 63.7363 147.752 63.7363 148.552V153H66.3763V147.928C66.3763 146.136 65.1923 144.808 63.3843 144.808C62.3283 144.808 61.4803 145.24 61.0163 145.864V144.936H58.3763V153ZM71.3338 153.128C72.1658 153.128 72.9178 152.84 73.3498 152.312V153.208C73.3498 153.816 72.9658 154.248 72.4378 154.248H68.7258V156.264H72.9178C74.7738 156.264 75.9738 155.192 75.9738 153.528V144.936H73.3338V145.576C72.9018 145.112 72.2298 144.808 71.2858 144.808C69.0138 144.808 67.5578 146.392 67.5578 148.968C67.5578 151.544 69.0138 153.128 71.3338 153.128ZM70.1338 148.968C70.1338 147.8 70.7898 147.048 71.7977 147.048C72.8218 147.048 73.4778 147.8 73.4778 148.968C73.4778 150.136 72.8218 150.888 71.7977 150.888C70.7898 150.888 70.1338 150.136 70.1338 148.968ZM34.7026 173H37.5506V168.648H41.5186V166.216H37.5506V164.232H42.5906V161.8H34.7026V173ZM46.8978 173.128C49.4098 173.128 51.2178 171.352 51.2178 168.968C51.2178 166.584 49.4098 164.808 46.8978 164.808C44.3858 164.808 42.5778 166.584 42.5778 168.968C42.5778 171.352 44.3858 173.128 46.8978 173.128ZM45.2178 168.968C45.2178 167.816 45.8898 167.048 46.8978 167.048C47.9058 167.048 48.5778 167.816 48.5778 168.968C48.5778 170.12 47.9058 170.888 46.8978 170.888C45.8898 170.888 45.2178 170.12 45.2178 168.968ZM56.2911 167.112H57.6991V164.936H56.8511C55.9551 164.936 55.3631 165.192 54.8991 166.152V164.936H52.2591V173H54.8991V168.92C54.8991 167.784 55.4111 167.112 56.2911 167.112ZM58.6341 173H61.2741V168.488C61.2741 167.592 61.7701 167.016 62.5221 167.016C63.2741 167.016 63.7701 167.592 63.7701 168.488V173H66.4101V168.488C66.4101 167.592 66.9061 167.016 67.6581 167.016C68.4101 167.016 68.9061 167.592 68.9061 168.488V173H71.5461V167.64C71.5461 166.152 70.3781 164.808 68.6181 164.808C67.2901 164.808 66.3141 165.464 65.8821 166.168C65.4501 165.288 64.7301 164.808 63.4981 164.808C62.4741 164.808 61.7541 165.256 61.2741 165.896V164.936H58.6341V173Z",
    fill: "#2356F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 121,
    width: 75,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 137,
    width: 148,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 169,
    width: 158,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 215,
    width: 165,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 185,
    width: 98,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 231,
    width: 98,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 201,
    width: 148,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 113,
    y: 153,
    width: 165,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 268,
    rx: 7.5,
    stroke: "#DADCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14008_88924",
    x: -34,
    y: -30,
    width: 363,
    height: 475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14008_88924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14008_88924",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14008_88924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftThird);
export default __webpack_public_path__ + "static/media/LeftThird.bebeeeb7a10c28101855101f51f7a23e.svg";
export { ForwardRef as ReactComponent };